<template>
  <div class="cms-form-group" :class="{ 'cms-form-group-full': fullWidth }">
    <label v-if="label">{{ label }}</label>
    <div class="cms-list-input">
      <div v-for="(item, index) in modelValue" :key="index" class="cms-list-item">
        <input
          :value="item"
          type="text"
          class="cms-input"
          :placeholder="placeholder"
          :disabled="disabled"
          @input="updateItem(index, ($event.target as HTMLInputElement).value)"
        />
        <cms-button
          variant="icon"
          icon="trash"
          :disabled="disabled"
          @click="removeItem(index)"
        />
      </div>
      <cms-button
        variant="secondary"
        icon="plus"
        :disabled="disabled"
        @click="addItem"
      >
        {{ addButtonText }}
      </cms-button>
    </div>
    <span v-if="helpText" class="cms-form-help">{{ helpText }}</span>
  </div>
</template>

<script lang="ts" setup>
import CmsButton from './CmsButton.vue';

interface Props {
  modelValue: string[];
  label?: string;
  placeholder?: string;
  addButtonText?: string;
  fullWidth?: boolean;
  helpText?: string;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  placeholder: '',
  addButtonText: 'Add',
  fullWidth: false,
  disabled: false
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: string[]): void;
}>();

const updateItem = (index: number, value: string) => {
  const newArray = [...props.modelValue];
  newArray[index] = value;
  emit('update:modelValue', newArray);
};

const removeItem = (index: number) => {
  const newArray = props.modelValue.filter((_, i) => i !== index);
  emit('update:modelValue', newArray);
};

const addItem = () => {
  emit('update:modelValue', [...props.modelValue, '']);
};
</script>

<style lang="scss" scoped>
@import './cms-styles.scss';

.cms-list-input {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.cms-list-item {
  display: flex;
  gap: $cms-spacing-sm;
  align-items: center;

  .cms-input {
    flex: 1;
    min-width: 0;
  }
}
</style>

